<template>
  <el-dialog
    :title="field(shopName) + '：满减活动'"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
    width="70%"
  >
    <!--工具条-->
    <Toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :selectBut="false"
    ></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
    >
      <el-table-column prop="Id" width="70" fixed></el-table-column>
      <el-table-column prop="Name" label="名称"></el-table-column>
      <el-table-column prop="Meet" label="满足金额"></el-table-column>
      <el-table-column prop="Derate" label="减免金额"></el-table-column>
      <el-table-column prop="Enabled" :label="$t('Enabled')" width="70">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? $t("enabled") : $t("disable") }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>

    <!--编辑界面-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="editForm" label-width="150px" ref="editForm">
        <el-form-item
          :label="$t('Name')"
          prop="Name"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Name'),
          }"
        >
          <el-input
            v-model="editForm.Name"
            maxlength="13"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="满足金额"
          prop="Meet"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '满足金额',
          }"
        >
          <el-input-number
            v-model.number="editForm.Meet"
            :precision="2"
            :step="0.1"
            :min="0"
            :max="999"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="减免金额"
          prop="Derate"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '减免金额',
          }"
        >
          <el-input-number
            v-model.number="editForm.Derate"
            :precision="2"
            :step="0.1"
            :min="0"
            :max="999"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('Enabled')">
          <el-switch v-model="editForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="addForm" label-width="150px" ref="addForm">
        <el-form-item
          :label="$t('Name')"
          prop="Name"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Name'),
          }"
        >
          <el-input
            v-model="addForm.Name"
            maxlength="13"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="满足金额"
          prop="Meet"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '满足金额',
          }"
        >
          <el-input-number
            v-model.number="addForm.Meet"
            :precision="2"
            :step="0.1"
            :min="0"
            :max="999"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="减免金额"
          prop="Derate"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '减免金额',
          }"
        >
          <el-input-number
            v-model.number="addForm.Derate"
            :precision="2"
            :step="0.1"
            :min="0"
            :max="999"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('Enabled')">
          <el-switch v-model="addForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
    <div slot="footer" class="dialog-footer"></div>
  </el-dialog>
</template>

<script>
import util from "util/date";
import {
  getShopDerateList,
  removeShopDerate,
  editShopDerate,
  addShopDerate,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  data() {
    return {
      filters: {
        Name: "",
      },
      dialogVisible: false,
      shopName: "",
      buttonList: [],
      list: [],
      listLoading: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {},
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    openTourDiyConfig(name, id) {
      this.$refs.tourDiyConfigDialog.loadData(name, id);
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    //获取列表
    getList() {
      let para = {
        shopId: this.shopId,
      };
      this.listLoading = true;
      getShopDerateList(para).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });
        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeShopDerate(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Name: "",
        Meet: 0,
        Derate: 0,
        Shop_Id: this.shopId,
        Enabled: true,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editShopDerate(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              para.IsDeleted = false;
              addShopDerate(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.addLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    loadData(sname, sid) {
      this.shopName = sname;
      this.shopId = sid;
      this.getList();
      this.dialogVisible = true;
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList("/ShopConfig/ShopDerate", routers);
    },
  },
};
</script>

<style scoped>
</style>
